module.exports = __webpack_public_path__ + "media/old_images/default-site-trail-e3fc9111.png";